import { Injectable } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  app: any;
  baseUrl: string;
  baseEventsUrl: string;
  basePartnerManagementApiUrl: string;

  constructor(private authenticationService: AuthenticationService) {
    this.app = {
      name: 'Microsoft 365 OSMOSIS Dashbaord',
      year: new Date().getFullYear()
    };
    this.baseUrl = environment.baseUrlApi;
    this.baseEventsUrl = environment.baseUrlEventsApi;
    this.basePartnerManagementApiUrl = environment.basePartnerManagementApiUrl;
  }
  getAppSetting(name) {
    return name ? this.app[name] : this.app;
  }

  getBadRequestErrors(error) {
    const errors: string[] = [];
    const jsonObj: any = JSON.parse(JSON.stringify(error.error));
    for (const prop in jsonObj) {
      errors.push(jsonObj[prop].toString());
    }
    return errors;
  }

  get AliasName(): string | null {
    return this.authenticationService.aliasName;
  }
}
